import { createSelector } from "reselect";

const selectFaq = (state) => state.faq;

export const selectFaqsForPreview = createSelector(
  [selectFaq],
  (faq) => faq.items
);

export const selectIsFaqLoading = createSelector([selectFaq], (faq) => {
  return faq.loading || !!!faq.items;
});
